





















import { Configuration, QualificationOverview, ConferenceDoctorQualificationRestControllerApi } from '@/types/api-docs'
import Utils from '@/utils/utils'
import { DataOptions, DataTableHeader } from 'vuetify'
import Vue from 'vue'

const qualificationApi = new ConferenceDoctorQualificationRestControllerApi(
  new Configuration({ basePath: `${window.location.origin}` })
)

export type DataType = {
  pageName: string
  breadcrumbs: unknown[]
  overviews?: QualificationOverview[]
  total?: number
  loading: boolean
  options: DataOptions
  headers: DataTableHeader[]
}

export default Vue.extend({
  components: {},
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      overviews: [],
      total: 0,
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      headers: [
        { text: 'No', value: 'id', width: '10%' },
        {
          text: '資格・認定名',
          value: 'qualificationName',
          width: '30%',
          sortable: false,
        },
        {
          text: '状態',
          value: 'status',
          width: '10%',
        },
        {
          text: '資格・認定番号',
          value: 'qualificationNumber',
          width: '20%',
          sortable: false,
        },
        {
          text: '取得年月日',
          value: 'dateFrom',
          width: '10%',
          sortable: false,
        },
        { text: '更新日', value: 'updateDate', width: '10%', sortable: false },
        {
          text: '次回更新日',
          value: 'dateTo',
          width: '10%',
          sortable: false,
        },
      ],
    }
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    async getDataFromApi() {
      this.loading = true
      const { data } = await qualificationApi.fetchQualificationOverviews(
        this.options.page - 1,
        this.options.itemsPerPage,
        Utils.parseSortQueryParams(this.options)
      )
      this.overviews = data.content
      this.total = data.totalElements
      this.loading = false
      if (data.totalPages && this.options.page > data.totalPages) {
        this.options.page = data.totalPages
      }
    },
  },
})
